import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get} from "lodash";

import DropdownDown from './assets/dropdown_arrow_down.svg';
import DropdownRight from './assets/dropdown_arrow_right.svg';

import Add from './assets/add.svg';
import GreenCheck from './assets/check_green.svg';



const styles = {
  mobileRow: {
    padding: "0px 0px 0px 8px",
    borderBottom: "1px solid #777777",
    color: "rgba(0, 0, 0, 0.87)",
    boxSizing: "border-box",
  },
  mobileRowHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerControl: {
    display: "flex",
    alignItems: "center",
  },
  mobileOrderId: {
    paddingLeft: "4px",
    color: "rgba(0, 0, 0, 0.87)",

  },
  mobileQty: {
    textAlign: "right",
  },
  rowAdd: {
    padding: "12px",
    cursor: 'pointer',
    '& img': {
      width: "24px",
      height: "24px",
    }
  },
  blueText: {
    color: "#5f00a0",
    cursor: "pointer",
  },
  orderHighlight: {
    fontWeight: "500",
  }

};

// const generateDate = date => {
//   const localDate = new Date(date + " UTC")
//   return localDate.toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false, minute: '2-digit' })//.replace(/,/g, "")
// }


const MobileSearchRow = (props) => {
  const { classes, language } = props;

  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <div className={classes.mobileRow} >
        <div className={classes.mobileRowHeader}>
          <div className={classes.headerControl}>
            <img src={isOpen ? DropdownDown : DropdownRight} onClick={() => setIsOpen(!isOpen)} alt="Dropdown" />
            <div className={classes.mobileOrderId} onClick={() => setIsOpen(!isOpen)}><span className={classes.orderHighlight}>{language === 'en' ? props.product.description_en : props.product.description_fr}</span></div>

          </div>
          <div className={`${classes.mobileQty} ${classes.blueText}`} > 
            <div className={classes.rowAdd} onClick={() => props.handleSelectProduct(props.product.product_id, props.product.zone_id, props.product.order_request_id, props.product.pzi_id)}>
              <img src={props.product.order_request_id ? GreenCheck : Add } alt="Add Order Request"/>
            </div>
          </div>

        </div>
        {isOpen?
          <>
            <div>{props.product.manufacturer_code}</div>
            <div>{props.product.manufacturer_name}</div>
            <div>{props.product.category}</div>
            <div>{props.product.assigned[0].split(" > ").slice(1).join(" > ")} ({props.product.pzi_id})</div>
            {/* {props.product.order_customer_order_id ? <div>{props.product.order_customer_order_id}</div> : null}
            <div>{I18n.get("events_createdBy")}: {props.product.created_by}</div>
            <div className={`${classes.mobileQtyCol} ${classes.blueText}`} ></div> */}
          </>
          : null
        }
        
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(MobileSearchRow))

);